import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { allAppsChangeDrawer } from "Store/appStore/action";
import { langCheck } from "Pub/js/utils";
import LogoIcon from "Assets/images/logo.svg";
import WhiteLogoIcon from "Assets/images/logo2.svg";
import noviceGuideAllapps from "Assets/images/noviceGuide/novice-guide-allapps.gif";
import RecentVisit from "./recentVisit";

class AllAppBtn extends React.Component {
    constructor(props) {
        super(props);
    }
    clickAllApply = () => {
        this.props.onAllAppClick(); //解决ie下点击全部应用浏览器假死问题
    };
    getBgImg = () => {
        const { themeColor, ispreview, navConfig = {}, onInsideNav = false } = this.props;
        const { theme = {} } = navConfig;
        let imgUrl;
        if (onInsideNav) { // 内部页签栏上的
            imgUrl = ['black'].includes(themeColor) ? WhiteLogoIcon : LogoIcon;
        } else {
            imgUrl = ['default', 'default1', 'mixin'].includes(ispreview ? theme.type : themeColor) ? LogoIcon : WhiteLogoIcon;
        }
        return `url(${imgUrl})`;
    }
    render() {
        const { onInsideNav, ispreview } = this.props;
        let allAppTip = `
        <img src=${noviceGuideAllapps} alt="" class='novice-guide-allapps' />
            <p>${langCheck('0000PUB-000291')}</p>
            <div class='span-box'>
                <span>${langCheck('0000PUB-000293')}</span>
            </div>
            <i class='iconfont icon-guanbi2 guide-close' onclick="handleWorkbenchIntro('close')"></i>
            `;
        return (
            <div
                className={`nc-workbench-allAppsBtn ${onInsideNav ? 'on-inside-nav' : 'on-workbench-nav'}`}
                onClick={this.clickAllApply}
            >
                <RecentVisit {...this.props}>
                    <div
                        className="nc-workbench-icon"
                        {...(ispreview ? {} : {
                            "data-step": "1",
                            "data-intro": allAppTip
                        })}
                    >
                        <i
                            style={{ backgroundImage: this.getBgImg() }}
                        />
                    </div>
                </RecentVisit>

            </div>
        );
    }
}
AllAppBtn.propTypes = {
    allAppsOpen: PropTypes.bool.isRequired,
    allAppsChangeDrawer: PropTypes.func.isRequired,
};
export default connect(
    state => ({
        allAppsOpen: state.appData.allAppsOpen,
        themeColor: state.appData.themeColor,
    }),
    { allAppsChangeDrawer },
)(AllAppBtn);
